import React, { Component } from 'react'
import { Card, Col } from 'antd'
import SearchBar from './SearchBar'
import './styles.css'

class CardObj extends Component {
  render() {
    const { event } = this.props
    // console.log(event)
    const tail = event.slug.split('-')
    const type = tail[tail.length - 1] === 'ecer' ? 'e-Certificate' : 'e-Slip'
    return (
      <div className="header-card-event">
        <Card className="content-card-event">
          <img src={event.logoImage} alt={this.props.logoImage} className="head-image-event" />

          <div style={{
                    textAlign: 'center',
                }}
          >
            <p className="text-event">{event.title}</p>
            <p style={{ fontFamily: 'Kanit-ExtraBold' }} >ใส่เบอร์บิบ เพื่อรับ {type} </p>
            <p style={{ fontFamily: 'Kanit-ExtraBold' }} >Enter you bib number for {type}</p>
          </div>
          <Col>
            {/* <SearchBar event={event} slug={this.props.slug}/> */}
            <SearchBar event={event} />
          </Col>
        </Card>

      </div>
    )
  }
}

export default CardObj



// WEBPACK FOOTER //
// ./src/Event/Component/CardObj.js